/* tslint:disable */
/* eslint-disable */
/**
 * Dataland Backend API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../../../../base';
// @ts-ignore
import type { CompanyAssociatedDataEutaxonomyFinancialsData } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { DataAndMetaInformationEutaxonomyFinancialsData } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { DataMetaInformation } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { ErrorResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { ExportJobInfo } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { ExportLatestRequestData } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
// @ts-ignore
import type { ExportRequestData } from '../../../../../../org/dataland/datalandfrontend/openApiClient/backend/model';
/**
 * EutaxonomyFinancialsDataControllerApi - axios parameter creator
 */
export const EutaxonomyFinancialsDataControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
         * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompanyEutaxonomyFinancialsData: async (companyId: string, showOnlyActive?: boolean, reportingPeriod?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getAllCompanyEutaxonomyFinancialsData', 'companyId', companyId)
            const localVarPath = `/data/eutaxonomy-financials/companies/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (showOnlyActive !== undefined) {
                localVarQueryParameter['showOnlyActive'] = showOnlyActive;
            }

            if (reportingPeriod !== undefined) {
                localVarQueryParameter['reportingPeriod'] = reportingPeriod;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} dataId The unique identifier of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAssociatedEutaxonomyFinancialsData: async (dataId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataId' is not null or undefined
            assertParamExists('getCompanyAssociatedEutaxonomyFinancialsData', 'dataId', dataId)
            const localVarPath = `/data/eutaxonomy-financials/{dataId}`
                .replace(`{${"dataId"}}`, encodeURIComponent(String(dataId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} reportingPeriod The relevant reporting period (e.g. a fiscal year).
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAssociatedEutaxonomyFinancialsDataByDimensions: async (reportingPeriod: string, companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportingPeriod' is not null or undefined
            assertParamExists('getCompanyAssociatedEutaxonomyFinancialsDataByDimensions', 'reportingPeriod', reportingPeriod)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getCompanyAssociatedEutaxonomyFinancialsDataByDimensions', 'companyId', companyId)
            const localVarPath = `/data/eutaxonomy-financials/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (reportingPeriod !== undefined) {
                localVarQueryParameter['reportingPeriod'] = reportingPeriod;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identifier Unique identifier to find a company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestAvailableCompanyAssociatedEutaxonomyFinancialsData: async (identifier: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identifier' is not null or undefined
            assertParamExists('getLatestAvailableCompanyAssociatedEutaxonomyFinancialsData', 'identifier', identifier)
            const localVarPath = `/data/eutaxonomy-financials/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (identifier !== undefined) {
                localVarQueryParameter['identifier'] = identifier;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompanyAssociatedDataEutaxonomyFinancialsData} companyAssociatedDataEutaxonomyFinancialsData 
         * @param {boolean} [bypassQa] If true, data is not sent to QA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompanyAssociatedEutaxonomyFinancialsData: async (companyAssociatedDataEutaxonomyFinancialsData: CompanyAssociatedDataEutaxonomyFinancialsData, bypassQa?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyAssociatedDataEutaxonomyFinancialsData' is not null or undefined
            assertParamExists('postCompanyAssociatedEutaxonomyFinancialsData', 'companyAssociatedDataEutaxonomyFinancialsData', companyAssociatedDataEutaxonomyFinancialsData)
            const localVarPath = `/data/eutaxonomy-financials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (bypassQa !== undefined) {
                localVarQueryParameter['bypassQa'] = bypassQa;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyAssociatedDataEutaxonomyFinancialsData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExportRequestData} exportRequestData 
         * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
         * @param {boolean} [includeAliases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postExportJobCompanyAssociatedEutaxonomyFinancialsDataByDimensions: async (exportRequestData: ExportRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportRequestData' is not null or undefined
            assertParamExists('postExportJobCompanyAssociatedEutaxonomyFinancialsDataByDimensions', 'exportRequestData', exportRequestData)
            const localVarPath = `/data/eutaxonomy-financials/export-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (keepValueFieldsOnly !== undefined) {
                localVarQueryParameter['keepValueFieldsOnly'] = keepValueFieldsOnly;
            }

            if (includeAliases !== undefined) {
                localVarQueryParameter['includeAliases'] = includeAliases;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportRequestData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExportLatestRequestData} exportLatestRequestData 
         * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
         * @param {boolean} [includeAliases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postExportLatestJobCompanyAssociatedEutaxonomyFinancialsDataByDimensions: async (exportLatestRequestData: ExportLatestRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportLatestRequestData' is not null or undefined
            assertParamExists('postExportLatestJobCompanyAssociatedEutaxonomyFinancialsDataByDimensions', 'exportLatestRequestData', exportLatestRequestData)
            const localVarPath = `/data/eutaxonomy-financials/export-latest-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (keepValueFieldsOnly !== undefined) {
                localVarQueryParameter['keepValueFieldsOnly'] = keepValueFieldsOnly;
            }

            if (includeAliases !== undefined) {
                localVarQueryParameter['includeAliases'] = includeAliases;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportLatestRequestData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EutaxonomyFinancialsDataControllerApi - functional programming interface
 */
export const EutaxonomyFinancialsDataControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EutaxonomyFinancialsDataControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
         * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCompanyEutaxonomyFinancialsData(companyId: string, showOnlyActive?: boolean, reportingPeriod?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataAndMetaInformationEutaxonomyFinancialsData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCompanyEutaxonomyFinancialsData(companyId, showOnlyActive, reportingPeriod, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EutaxonomyFinancialsDataControllerApi.getAllCompanyEutaxonomyFinancialsData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} dataId The unique identifier of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyAssociatedEutaxonomyFinancialsData(dataId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyAssociatedDataEutaxonomyFinancialsData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyAssociatedEutaxonomyFinancialsData(dataId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EutaxonomyFinancialsDataControllerApi.getCompanyAssociatedEutaxonomyFinancialsData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} reportingPeriod The relevant reporting period (e.g. a fiscal year).
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyAssociatedEutaxonomyFinancialsDataByDimensions(reportingPeriod: string, companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyAssociatedDataEutaxonomyFinancialsData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyAssociatedEutaxonomyFinancialsDataByDimensions(reportingPeriod, companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EutaxonomyFinancialsDataControllerApi.getCompanyAssociatedEutaxonomyFinancialsDataByDimensions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} identifier Unique identifier to find a company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestAvailableCompanyAssociatedEutaxonomyFinancialsData(identifier: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyAssociatedDataEutaxonomyFinancialsData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestAvailableCompanyAssociatedEutaxonomyFinancialsData(identifier, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EutaxonomyFinancialsDataControllerApi.getLatestAvailableCompanyAssociatedEutaxonomyFinancialsData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CompanyAssociatedDataEutaxonomyFinancialsData} companyAssociatedDataEutaxonomyFinancialsData 
         * @param {boolean} [bypassQa] If true, data is not sent to QA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCompanyAssociatedEutaxonomyFinancialsData(companyAssociatedDataEutaxonomyFinancialsData: CompanyAssociatedDataEutaxonomyFinancialsData, bypassQa?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataMetaInformation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCompanyAssociatedEutaxonomyFinancialsData(companyAssociatedDataEutaxonomyFinancialsData, bypassQa, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EutaxonomyFinancialsDataControllerApi.postCompanyAssociatedEutaxonomyFinancialsData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ExportRequestData} exportRequestData 
         * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
         * @param {boolean} [includeAliases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postExportJobCompanyAssociatedEutaxonomyFinancialsDataByDimensions(exportRequestData: ExportRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportJobInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postExportJobCompanyAssociatedEutaxonomyFinancialsDataByDimensions(exportRequestData, keepValueFieldsOnly, includeAliases, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EutaxonomyFinancialsDataControllerApi.postExportJobCompanyAssociatedEutaxonomyFinancialsDataByDimensions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ExportLatestRequestData} exportLatestRequestData 
         * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
         * @param {boolean} [includeAliases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postExportLatestJobCompanyAssociatedEutaxonomyFinancialsDataByDimensions(exportLatestRequestData: ExportLatestRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportJobInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postExportLatestJobCompanyAssociatedEutaxonomyFinancialsDataByDimensions(exportLatestRequestData, keepValueFieldsOnly, includeAliases, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EutaxonomyFinancialsDataControllerApi.postExportLatestJobCompanyAssociatedEutaxonomyFinancialsDataByDimensions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EutaxonomyFinancialsDataControllerApi - factory interface
 */
export const EutaxonomyFinancialsDataControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EutaxonomyFinancialsDataControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
         * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCompanyEutaxonomyFinancialsData(companyId: string, showOnlyActive?: boolean, reportingPeriod?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataAndMetaInformationEutaxonomyFinancialsData>> {
            return localVarFp.getAllCompanyEutaxonomyFinancialsData(companyId, showOnlyActive, reportingPeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} dataId The unique identifier of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAssociatedEutaxonomyFinancialsData(dataId: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAssociatedDataEutaxonomyFinancialsData> {
            return localVarFp.getCompanyAssociatedEutaxonomyFinancialsData(dataId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} reportingPeriod The relevant reporting period (e.g. a fiscal year).
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyAssociatedEutaxonomyFinancialsDataByDimensions(reportingPeriod: string, companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAssociatedDataEutaxonomyFinancialsData> {
            return localVarFp.getCompanyAssociatedEutaxonomyFinancialsDataByDimensions(reportingPeriod, companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identifier Unique identifier to find a company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestAvailableCompanyAssociatedEutaxonomyFinancialsData(identifier: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAssociatedDataEutaxonomyFinancialsData> {
            return localVarFp.getLatestAvailableCompanyAssociatedEutaxonomyFinancialsData(identifier, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CompanyAssociatedDataEutaxonomyFinancialsData} companyAssociatedDataEutaxonomyFinancialsData 
         * @param {boolean} [bypassQa] If true, data is not sent to QA.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCompanyAssociatedEutaxonomyFinancialsData(companyAssociatedDataEutaxonomyFinancialsData: CompanyAssociatedDataEutaxonomyFinancialsData, bypassQa?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DataMetaInformation> {
            return localVarFp.postCompanyAssociatedEutaxonomyFinancialsData(companyAssociatedDataEutaxonomyFinancialsData, bypassQa, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExportRequestData} exportRequestData 
         * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
         * @param {boolean} [includeAliases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postExportJobCompanyAssociatedEutaxonomyFinancialsDataByDimensions(exportRequestData: ExportRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ExportJobInfo> {
            return localVarFp.postExportJobCompanyAssociatedEutaxonomyFinancialsDataByDimensions(exportRequestData, keepValueFieldsOnly, includeAliases, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExportLatestRequestData} exportLatestRequestData 
         * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
         * @param {boolean} [includeAliases] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postExportLatestJobCompanyAssociatedEutaxonomyFinancialsDataByDimensions(exportLatestRequestData: ExportLatestRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ExportJobInfo> {
            return localVarFp.postExportLatestJobCompanyAssociatedEutaxonomyFinancialsDataByDimensions(exportLatestRequestData, keepValueFieldsOnly, includeAliases, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EutaxonomyFinancialsDataControllerApi - interface
 */
export interface EutaxonomyFinancialsDataControllerApiInterface {
    /**
     * 
     * @param {string} companyId The unique identifier under which a company can be found on Dataland.
     * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
     * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllCompanyEutaxonomyFinancialsData(companyId: string, showOnlyActive?: boolean, reportingPeriod?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataAndMetaInformationEutaxonomyFinancialsData>>;

    /**
     * 
     * @param {string} dataId The unique identifier of the dataset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyAssociatedEutaxonomyFinancialsData(dataId: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAssociatedDataEutaxonomyFinancialsData>;

    /**
     * 
     * @param {string} reportingPeriod The relevant reporting period (e.g. a fiscal year).
     * @param {string} companyId The unique identifier under which a company can be found on Dataland.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyAssociatedEutaxonomyFinancialsDataByDimensions(reportingPeriod: string, companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAssociatedDataEutaxonomyFinancialsData>;

    /**
     * 
     * @param {string} identifier Unique identifier to find a company.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLatestAvailableCompanyAssociatedEutaxonomyFinancialsData(identifier: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyAssociatedDataEutaxonomyFinancialsData>;

    /**
     * 
     * @param {CompanyAssociatedDataEutaxonomyFinancialsData} companyAssociatedDataEutaxonomyFinancialsData 
     * @param {boolean} [bypassQa] If true, data is not sent to QA.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postCompanyAssociatedEutaxonomyFinancialsData(companyAssociatedDataEutaxonomyFinancialsData: CompanyAssociatedDataEutaxonomyFinancialsData, bypassQa?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DataMetaInformation>;

    /**
     * 
     * @param {ExportRequestData} exportRequestData 
     * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
     * @param {boolean} [includeAliases] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postExportJobCompanyAssociatedEutaxonomyFinancialsDataByDimensions(exportRequestData: ExportRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ExportJobInfo>;

    /**
     * 
     * @param {ExportLatestRequestData} exportLatestRequestData 
     * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
     * @param {boolean} [includeAliases] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postExportLatestJobCompanyAssociatedEutaxonomyFinancialsDataByDimensions(exportLatestRequestData: ExportLatestRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ExportJobInfo>;

}

/**
 * EutaxonomyFinancialsDataControllerApi - object-oriented interface
 */
export class EutaxonomyFinancialsDataControllerApi extends BaseAPI implements EutaxonomyFinancialsDataControllerApiInterface {
    /**
     * 
     * @param {string} companyId The unique identifier under which a company can be found on Dataland.
     * @param {boolean} [showOnlyActive] Boolean parameter. If set to true or empty, only currently active data is returned. If set to false, all data is returned regardless of active status.
     * @param {string} [reportingPeriod] The relevant reporting period (e.g. a fiscal year).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllCompanyEutaxonomyFinancialsData(companyId: string, showOnlyActive?: boolean, reportingPeriod?: string, options?: RawAxiosRequestConfig) {
        return EutaxonomyFinancialsDataControllerApiFp(this.configuration).getAllCompanyEutaxonomyFinancialsData(companyId, showOnlyActive, reportingPeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} dataId The unique identifier of the dataset.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCompanyAssociatedEutaxonomyFinancialsData(dataId: string, options?: RawAxiosRequestConfig) {
        return EutaxonomyFinancialsDataControllerApiFp(this.configuration).getCompanyAssociatedEutaxonomyFinancialsData(dataId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} reportingPeriod The relevant reporting period (e.g. a fiscal year).
     * @param {string} companyId The unique identifier under which a company can be found on Dataland.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCompanyAssociatedEutaxonomyFinancialsDataByDimensions(reportingPeriod: string, companyId: string, options?: RawAxiosRequestConfig) {
        return EutaxonomyFinancialsDataControllerApiFp(this.configuration).getCompanyAssociatedEutaxonomyFinancialsDataByDimensions(reportingPeriod, companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identifier Unique identifier to find a company.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLatestAvailableCompanyAssociatedEutaxonomyFinancialsData(identifier: string, options?: RawAxiosRequestConfig) {
        return EutaxonomyFinancialsDataControllerApiFp(this.configuration).getLatestAvailableCompanyAssociatedEutaxonomyFinancialsData(identifier, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CompanyAssociatedDataEutaxonomyFinancialsData} companyAssociatedDataEutaxonomyFinancialsData 
     * @param {boolean} [bypassQa] If true, data is not sent to QA.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postCompanyAssociatedEutaxonomyFinancialsData(companyAssociatedDataEutaxonomyFinancialsData: CompanyAssociatedDataEutaxonomyFinancialsData, bypassQa?: boolean, options?: RawAxiosRequestConfig) {
        return EutaxonomyFinancialsDataControllerApiFp(this.configuration).postCompanyAssociatedEutaxonomyFinancialsData(companyAssociatedDataEutaxonomyFinancialsData, bypassQa, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExportRequestData} exportRequestData 
     * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
     * @param {boolean} [includeAliases] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postExportJobCompanyAssociatedEutaxonomyFinancialsDataByDimensions(exportRequestData: ExportRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig) {
        return EutaxonomyFinancialsDataControllerApiFp(this.configuration).postExportJobCompanyAssociatedEutaxonomyFinancialsDataByDimensions(exportRequestData, keepValueFieldsOnly, includeAliases, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExportLatestRequestData} exportLatestRequestData 
     * @param {boolean} [keepValueFieldsOnly] If set to true, data is to be exported without additional information like comments on the data or the data\&#39;s qa status.
     * @param {boolean} [includeAliases] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postExportLatestJobCompanyAssociatedEutaxonomyFinancialsDataByDimensions(exportLatestRequestData: ExportLatestRequestData, keepValueFieldsOnly?: boolean, includeAliases?: boolean, options?: RawAxiosRequestConfig) {
        return EutaxonomyFinancialsDataControllerApiFp(this.configuration).postExportLatestJobCompanyAssociatedEutaxonomyFinancialsDataByDimensions(exportLatestRequestData, keepValueFieldsOnly, includeAliases, options).then((request) => request(this.axios, this.basePath));
    }
}

